import axios from "axios";
import {
  BoostEligibility,
  AdAccount,
  TargetingInterest,
  TargetingLocation,
  BoostConfig,
  BoostResult,
  PostBoostHistory,
} from "../types";

const BASE_URL = "/boost";

/**
 * Check whether a post is eligible for boosting
 */
export async function checkBoostEligibility(
  postId: string
): Promise<BoostEligibility> {
  const response = await axios.get<BoostEligibility>(
    `${BASE_URL}/${postId}/eligibility`
  );
  return response.data;
}

/**
 * Fetch all ad accounts available for boosting
 */
export async function getAdAccounts(): Promise<AdAccount[]> {
  const response = await axios.get<AdAccount[]>(`${BASE_URL}/ad-accounts`);
  return response.data;
}

/**
 * Search targeting interests by query string
 */
export async function searchInterests(
  query: string
): Promise<TargetingInterest[]> {
  const response = await axios.get<TargetingInterest[]>(
    `${BASE_URL}/targeting/interests`,
    { params: { q: query } }
  );
  return response.data;
}

/**
 * Search targeting locations by query string
 */
export async function searchLocations(
  query: string
): Promise<TargetingLocation[]> {
  const response = await axios.get<TargetingLocation[]>(
    `${BASE_URL}/targeting/locations`,
    { params: { q: query } }
  );
  return response.data;
}

/**
 * Create a boost (promoted ad) for a post
 */
export async function createBoost(
  postId: string,
  config: BoostConfig
): Promise<BoostResult> {
  const response = await axios.post<BoostResult>(
    `${BASE_URL}/${postId}`,
    config
  );
  return response.data;
}

/**
 * Fetch successful boosts previously created for a post, newest first.
 */
export async function getPostBoostHistory(
  postId: string
): Promise<PostBoostHistory> {
  const response = await axios.get<PostBoostHistory>(
    `${BASE_URL}/${postId}/history`
  );
  return response.data;
}
